module.exports = __webpack_public_path__ + "static/media/opakowania_1_B.af229fba.png";